// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__o19ON","flat__":"Icon_flat____IQZWR"};